import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import { Col, Container, Row } from "react-bootstrap";
import { yesNoRadioList } from "../../../../TCPForms/data";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Swal from "sweetalert2";
import ReactToPrint from "react-to-print";
import PrintIcon from "@mui/icons-material/Print";

const SubStep4 = ({ formData, handleTabChange, t, isAssignedLTP, applicationData, handleSubTabChange, isEmployee, isApproved }) => {
  const defaultValues = {
    ...formData,
  };

  const { handleSubmit, control, reset, getValues, watch, setValue } = useForm({ defaultValues });
  const [permissibleFAR, setPermissibleFAR] = useState(formData?.taxHeadEstimates?.[0]?.permissibleFAR);
  const takenFAR = watch("descriptionOfLand.properties[0].takenFAR");
  const percentageFAR = watch("descriptionOfLand.properties[0].percentRequiredFAR");
  const plotArea = applicationData?.descriptionOfLand?.landArea;
  const takenFarValue = watch("descriptionOfLand.properties[0].purchasableFAR");
  // const permissibleFar = takenFAR
  //   ? Number(takenFAR) + Number(formData?.taxHeadEstimates?.[0]?.permissibleFAR)
  //   : Number(formData?.taxHeadEstimates?.[0]?.permissibleFAR);
  console.log(
    "Number(plotArea * (percentageFAR).toFixed(2)",
    Number(plotArea * percentageFAR).toFixed(2),
    plotArea,
    percentageFAR,
    applicationData?.descriptionOfLand?.landArea
  );
  const calculatePercentage = (developmentType, roadWidth) => {
    if (developmentType === "Built Up") {
      return 20;
    } else {
      if (Number(roadWidth) > 18 && Number(roadWidth) < 24) {
        return 33;
      } else if (Number(roadWidth) >= 24) {
        return 50;
      }
    }
  };
  console.log("dataFromLandUSe", applicationData, formData);
  const percentPermissibleFAR = calculatePercentage(
    formData?.descriptionOfLand?.properties?.[0]?.constructionType,
    formData?.descriptionOfLand?.properties?.[0]?.roadWidth
  );

  const LandDetailsTable = () => {
    const taxData = formData?.taxHeadEstimates?.[0] || {};
    const landProps = formData?.descriptionOfLand?.properties?.[0] || {};
    const printRef = useRef();

    const rows = [
      {
        label: "Building Category of Plot",
        value: applicationData?.descriptionOfLand?.landUsesType || "-",
      },
      {
        label: "Sub-category of Plot",
        value: applicationData?.descriptionOfLand?.subLandUseAsPerLayout || "-",
      },
      {
        label: "Development Zone",
        value: landProps?.constructionType || "-",
      },
      {
        label: "",
        value: "",
      },
      {
        label: "Plot Area(Sqmt.)",
        value: landProps?.landArea || "-",
      },
      {
        label: "Existing Road Width(Mt.)",
        value: landProps?.roadWidth || "-",
      },
      {
        label: "Basic FAR(Factor)",
        value: taxData?.basicFar || "-",
      },
      {
        label: "Basic FAR Area(Sqmt.)",
        value: taxData?.totalBuiltUpArea || "-",
      },
      {
        label: "Permissible FAR(Factor)",
        value: `${taxData?.basicFar || "-"} * ${percentPermissibleFAR || "-"}% = ${taxData?.permissibleFAR || "-"}`,
      },
      {
        label: "Permissible FAR Area(Sqmt.)",
        value: taxData?.permissibleFARArea || "-",
      },
      {
        label: "Total Permissible FAR(Factor)",
        value: taxData?.totalPermissibleFar || "-",
      },
      {
        label: "Total Permissible FAR Area(Sqmt.)",
        value: taxData?.totalPermissibleFARArea || "-",
      },
    ];

    return (
      <div className="land-details-table-wrapper">
        <h3 className="far-print-table-header">
          FAR Details
          <ReactToPrint
            trigger={() => (
              <button type="button">
                <span>
                  <PrintIcon sx={{ fontSize: "13px" }} />
                </span>
                Print
              </button>
            )}
            content={() => printRef.current}
          />
        </h3>

        <div ref={printRef}>
          <table className="land-details-table">
            <tbody>
              {(() => {
                const pairedRows = [];
                for (let i = 0; i < rows.length; i += 2) {
                  pairedRows.push(
                    <tr key={i}>
                      <td>
                        <strong>{rows[i].label}</strong>
                      </td>
                      <td>{rows[i].value}</td>
                      {rows[i + 1] ? (
                        <React.Fragment>
                          <td>
                            <strong>{rows[i + 1].label}</strong>
                          </td>
                          <td>{rows[i + 1].value}</td>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <td></td>
                          <td></td>
                        </React.Fragment>
                      )}
                    </tr>
                  );
                }
                return pairedRows;
              })()}
            </tbody>
          </table>
        </div>
      </div>
    );
  };
  //   const assessmentCriteria = `<div style="display: flex;justify-content: space-evenly; gap: 20px;">
  // <!-- First column: List structure -->
  //   <div>
  //     <ul class="installment-breakdown">
  //       <li><strong>Building Category of Plot: </strong>${applicationData?.descriptionOfLand?.landUsesType || ""}</li>
  //       <li><strong>Sub-category of Plot: </strong>${applicationData?.descriptionOfLand?.subLandUseAsPerLayout || ""}</li>
  //       <li><strong>Development Zone: </strong>${formData?.descriptionOfLand?.properties?.[0]?.constructionType || ""}</li>
  //       <li><strong>Existing Road Width: </strong>${formData?.descriptionOfLand?.properties?.[0]?.roadWidth || ""}</li>
  //    <li><strong>Basic FAR: </strong>${formData?.taxHeadEstimates?.[0]?.basicFar || ""}</li>
  //    <li><strong>Plot Area: </strong>${formData?.descriptionOfLand?.properties?.[0]?.landArea || ""}</li>
  //    <li><strong>Total FAR Area (SqM): </strong>${formData?.taxHeadEstimates?.[0]?.totalBuiltUpArea || ""}</li>
  //   <li><strong>Permissible Purchasable FAR: </strong>${formData?.taxHeadEstimates?.[0]?.basicFar || ""} * ${percentPermissibleFAR || ""}% = ${
  //     formData?.taxHeadEstimates?.[0]?.permissibleFAR || ""
  //   }</li>
  //   <li><strong>Permissible Purchasable FAR Area: </strong>${formData?.taxHeadEstimates?.[0]?.permissibleFARArea || ""}</li>
  //   <li><strong>Total Permissible Purchasable FAR: </strong>${formData?.taxHeadEstimates?.[0]?.totalPermissibleFar || ""}</li>
  //   <li><strong>Total Permissible Purchasable FAR Area: </strong>${formData?.taxHeadEstimates?.[0]?.totalPermissibleFARArea || ""}</li>
  //     </ul>
  //   </div>
  // `;
  // <li><strong>Already taken FAR if any: </strong></li>

  const handleInfoClick = () => {
    Swal.fire({
      title: "Assessment Criteria",
      html: assessmentCriteria,
      icon: null,
      backdrop: true,
      allowOutsideClick: false,
      customClass: {
        popup: "farDetail-info-modal", // Custom class for the modal
        title: "farDetail-info-modal-title", // Custom class for the title
        content: "farDetail-info-modal-content", // Custom class for the content
      },
    });
  };
  // const handleAreaFar = () => {
  //   setValue("descriptionOfLand.properties[0].requiredAreaFAR", Number(plotArea * percentageFAR).toFixed(2));
  // };
  const handleAreaFar = (type) => {
    const far = getValues("descriptionOfLand.properties[0].percentRequiredFAR");
    const area = getValues("descriptionOfLand.properties[0].requiredAreaFAR");

    if (type === "far") {
      const calculatedArea = Math.floor(plotArea * Number(far || 0) * 100) / 100;
      console.log("calculatedArea", calculatedArea, plotArea, far);

      setValue("descriptionOfLand.properties[0].requiredAreaFAR", calculatedArea.toFixed(2));
    } else if (type === "area") {
      const calculatedFAR = Math.floor((Number(area) / plotArea) * 100) / 100;
      console.log("calculatedFAR", calculatedFAR, plotArea, area);

      setValue("descriptionOfLand.properties[0].percentRequiredFAR", calculatedFAR.toFixed(2));
    }
  };
  const onSubmit = (data) => {
    handleTabChange(1, data);
  };
  useEffect(() => {
    if (takenFarValue) {
      setPermissibleFAR((Number(formData?.taxHeadEstimates?.[0]?.permissibleFAR) - Number(takenFarValue)).toFixed(2));
    }
  }, [takenFarValue]);
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <LandDetailsTable />
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("LABEL_FAR_DETAILS")}</h2>
          </div>

          <Container fluid className="formInputContainer">
            {/* <Row>
              <Col>
                <div
                  style={{
                    // padding: "6px",
                    borderRadius: "5px",
                    color: "#333",
                    marginTop: "9px",
                    fontWeight: "600",
                    textAlign: "right",
                  }}
                >
                  <span style={{ textAlign: "right", color: "rgb(21, 124, 179)", padding: "9px", backgroundColor: "#f5f5f5" }}>
                    <span className="farDetail-info-icon" onClick={handleInfoClick}>
                      <InfoOutlinedIcon />
                    </span>
                    Information on how applications are assessed.
                  </span>
                </div>
              </Col>
            </Row> */}
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("LABEL_ALREADY_TAKEN_FAR")}
                  // defaultValue={descriptionOfLand?.takenFAR}
                  name="descriptionOfLand.properties[0].takenFAR"
                  type="radioButton"
                  data={yesNoRadioList}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                  disabled={isEmployee || isApproved || Boolean(isAssignedLTP)}
                  isApproved={true}
                  // disabled={Boolean(isAssignedLTP)} // Add disabled here
                />
              </Col>
              {takenFAR === "Yes" ? (
                <Col>
                  <InputWrapper
                    control={control}
                    label={t("LABEL_TAKEN_PURCHASABLE_FAR")}
                    placeholder={t("LABEL_ENTER_TAKEN_PURCHASABLE_FAR")}
                    name="descriptionOfLand.properties[0].purchasableFAR"
                    type="decimal"
                    disabled={isEmployee || isApproved}
                    isApproved={true}
                    // defaultValue={descriptionOfLand?.purchasableFAR}
                    // disabled={Boolean(isAssignedLTP)} // Add disabled here
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            <Row>
              <Col onBlur={() => handleAreaFar("far")}>
                <InputWrapper
                  control={control}
                  label={t("Required FAR")}
                  placeholder={t("Enter required FAR")}
                  // defaultValue={descriptionOfLand?.percentRequiredFAR}
                  name="descriptionOfLand.properties[0].percentRequiredFAR"
                  type="decimal"
                  mandatory
                  isRequired={true}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  maxLength={5}
                  maxValue={permissibleFAR || ""}
                  disabled={isEmployee || isApproved || Boolean(isAssignedLTP)}
                  isApproved={true}
                  // disabled={Boolean(isAssignedLTP)} // Add disabled here
                />
              </Col>
              <Col onBlur={() => handleAreaFar("area")}>
                <InputWrapper
                  control={control}
                  label={t("Required FAR Area (Sq. Meter)")}
                  name="descriptionOfLand.properties[0].requiredAreaFAR"
                  type="decimal"
                  isRequired={true}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  mandatory
                  required
                  disabled={Boolean(isAssignedLTP) || isEmployee || isApproved}
                />
              </Col>
            </Row>
          </Container>
          <div className="footerContainer2">
            {!isEmployee && !isApproved && (
              <div className="buttonWrapper">
                <ButtonWrapper
                  variant="contained"
                  color="error"
                  size="medium"
                  label="Prev"
                  sx={{ backgroundColor: "#CCC", marginRight: "4px" }}
                  onClick={() => handleSubTabChange(2)}
                />
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label="Save"
                  type="submit"
                  sx={{ backgroundColor: "#157CB3", marginRight: "4px" }}
                />
              </div>
            )}
          </div>
        </div>
      </form>
    </section>
  );
};

export default SubStep4;
